import { render } from "./DropdownUi.vue?vue&type=template&id=624ac44b&ts=true"
import script from "./DropdownUi.vue?vue&type=script&lang=ts"
export * from "./DropdownUi.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__